import Cookies from 'js-cookie';
import { DEFAULT_LANG } from './constants';

export function getHeaders() {
  return {
    Authorization: `Bearer ${Cookies.get('authToken')}`,
    'X-User': 'admin',
  };
}

export function contentAccordingToLang(data) {
  if (!data.length) return null;

  const currentLang = Cookies.get('lang') || DEFAULT_LANG?.value;
  return (
    data.find(el => el.lang === currentLang) ||
    data.find(el => el.lang === 'en') ||
    data.find(el => el.lang) || // Get the first valid entry
    data[0] // Just in case there's any undefined or null entry
  );
}
